export default __webpack_public_path__ + "static/media/gallery15.72e640aa.webp";